import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=4be9f35f&scoped=true&"
import script from "./Tour.vue?vue&type=script&lang=js&"
export * from "./Tour.vue?vue&type=script&lang=js&"
import style0 from "./Tour.vue?vue&type=style&index=0&id=4be9f35f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be9f35f",
  null
  
)

export default component.exports